export type EnvironmentName = "mc" | "ff" | "usnat" | "ussec" | "prod";

const sideloadWithDogfoodClientId = true;

const Analyzer: {
    defaultCloud: EnvironmentName;
    instrumentationKey: string;
    serviceClientId: string;
} = (window as any).Analyzer || {
    defaultCloud: "prod",
    serviceClientId: sideloadWithDogfoodClientId ? "bbefd4b6-1079-4122-b895-3fa9271cd994" : "3a95cbc7-54a5-4449-b153-9cc4fc66f609",
    instrumentationKey: "acdb6d9a-2199-4f3b-8adc-0dd1766afbcd"
};

export const defaultCloud = Analyzer.defaultCloud;
export const serviceClientId = Analyzer.serviceClientId;
export const useFirstPartyClientId = serviceClientId === "3a95cbc7-54a5-4449-b153-9cc4fc66f609";
export const instrumentationKey = Analyzer.instrumentationKey;
export const copilotBaseUrl = "/api/copilot";
export const cloud = defaultCloud;
export const iconBaseUrl = "/icons/";
export const sfiReportsStorageAccount = "axesfi";
export const sfiReportsContainer = "reports";

// Storage location for published AX&E Livesite (on-call) summary reports.
// TODO: confirm the actual account/container for published livesite reports;
// these mirror the SFI convention as a placeholder.
export const livesiteReportsStorageAccount = "axelivesite";
export const livesiteReportsContainer = "reports";

export const corpTenantId = "72f988bf-86f1-41af-91ab-2d7cd011db47";
export const ameTenantId = "33e01921-4d64-4f8c-a055-5bdaffd5e33d";
export const pmeTenantId = "975f013f-7f24-47e8-a7d3-abc4752bf346";

export const cloudDisplayNames: { [key in EnvironmentName]: string; } = {
    prod: "Public Azure (portal.azure.com)",
    ff: "Fairfax (portal.azure.us)",
    mc: "Mooncake (portal.azure.cn)",
    usnat: "USNat (portal.azure.eaglex.ic.gov)",
    ussec: "USSec (portal.azure.microsoft.scloud)",
};
export const cloudDisplayName = cloudDisplayNames[cloud];

const reportABugLinks: { [key in EnvironmentName]: string; } = {
    prod: "https://aka.ms/portalfx/extensionanalyzerbug",
    ff: "https://aka.ms/portalfx/extensionanalyzerbug",
    mc: "https://aka.ms/portalfx/extensionanalyzerbug",
    usnat: "https://aka.eaglex.ic.gov/portalfx/extensionanalyzerbug",
    ussec: "https://aka.microsoft.scloud/portalfx/extensionanalyzerbug",
};

export const reportABugLink = reportABugLinks[cloud];

export const enum SovereignFeatureKeys {
    Experimentation = "Experimentation",
    CloudSwitcher = "CloudSwitcher",
    ProductsExtensions = "Products & Extensions",
    BuildsDeployments = "Builds and deployments",
    Controllers = "Controllers",
    PartnerTests = "Partner Tests Directory",
    AzureExperienceQuality = "Azure Experience Quality",
    SFIReporting = "SFI Reporting",
    LivesiteReporting = "Livesite Reporting",
    BAMITenantManagement = "BAMI Tenant Management",
    TopbarFeedbackPane = "Topbar Feedback Pane",
    CESCVA = "CES/CVA",
    EV2Experiments = "EV2 Experiments",
    Lighthouse = "Lighthouse",
    Dashboards = "Dashboards",
    FeedbackTelemetry = "FeedbackTelemetry",
    Copilot = "Copilot"
}

const hideSovereignFeatures: { [key in EnvironmentName]: Record<SovereignFeatureKeys, boolean> } = {
    prod: {
        [SovereignFeatureKeys.Experimentation]: false,
        [SovereignFeatureKeys.CloudSwitcher]: false,
        [SovereignFeatureKeys.ProductsExtensions]: false,
        [SovereignFeatureKeys.BuildsDeployments]: false,
        [SovereignFeatureKeys.Controllers]: false,
        [SovereignFeatureKeys.PartnerTests]: false,
        [SovereignFeatureKeys.AzureExperienceQuality]: false,
        [SovereignFeatureKeys.SFIReporting]: false,
        [SovereignFeatureKeys.LivesiteReporting]: false,
        [SovereignFeatureKeys.BAMITenantManagement]: false,
        [SovereignFeatureKeys.TopbarFeedbackPane]: false,
        [SovereignFeatureKeys.CESCVA]: false,
        [SovereignFeatureKeys.EV2Experiments]: false,
        [SovereignFeatureKeys.Lighthouse]: false,
        [SovereignFeatureKeys.Dashboards]: false,
        [SovereignFeatureKeys.FeedbackTelemetry]: false,
        [SovereignFeatureKeys.Copilot]: false,
    },
    mc: {
        [SovereignFeatureKeys.Experimentation]: false,
        [SovereignFeatureKeys.CloudSwitcher]: false,
        [SovereignFeatureKeys.ProductsExtensions]: false,
        [SovereignFeatureKeys.BuildsDeployments]: false,
        [SovereignFeatureKeys.Controllers]: false,
        [SovereignFeatureKeys.PartnerTests]: false,
        [SovereignFeatureKeys.AzureExperienceQuality]: false,
        [SovereignFeatureKeys.SFIReporting]: false,
        [SovereignFeatureKeys.LivesiteReporting]: false,
        [SovereignFeatureKeys.BAMITenantManagement]: false,
        [SovereignFeatureKeys.TopbarFeedbackPane]: false,
        [SovereignFeatureKeys.CESCVA]: false,
        [SovereignFeatureKeys.EV2Experiments]: false,
        [SovereignFeatureKeys.Lighthouse]: false,
        [SovereignFeatureKeys.Dashboards]: false,
        [SovereignFeatureKeys.FeedbackTelemetry]: false,
        [SovereignFeatureKeys.Copilot]: false,
    },
    ff: {
        [SovereignFeatureKeys.Experimentation]: false,
        [SovereignFeatureKeys.CloudSwitcher]: false,
        [SovereignFeatureKeys.ProductsExtensions]: false,
        [SovereignFeatureKeys.BuildsDeployments]: false,
        [SovereignFeatureKeys.Controllers]: false,
        [SovereignFeatureKeys.PartnerTests]: false,
        [SovereignFeatureKeys.AzureExperienceQuality]: false,
        [SovereignFeatureKeys.SFIReporting]: false,
        [SovereignFeatureKeys.LivesiteReporting]: false,
        [SovereignFeatureKeys.BAMITenantManagement]: false,
        [SovereignFeatureKeys.TopbarFeedbackPane]: false,
        [SovereignFeatureKeys.CESCVA]: false,
        [SovereignFeatureKeys.EV2Experiments]: false,
        [SovereignFeatureKeys.Lighthouse]: false,
        [SovereignFeatureKeys.Dashboards]: false,
        [SovereignFeatureKeys.FeedbackTelemetry]: false,
        [SovereignFeatureKeys.Copilot]: false,
    },
    usnat: {
        [SovereignFeatureKeys.Experimentation]: true,
        [SovereignFeatureKeys.CloudSwitcher]: true,
        [SovereignFeatureKeys.ProductsExtensions]: false,
        [SovereignFeatureKeys.BuildsDeployments]: true,
        [SovereignFeatureKeys.Controllers]: true,
        [SovereignFeatureKeys.PartnerTests]: true,
        [SovereignFeatureKeys.AzureExperienceQuality]: true,
        [SovereignFeatureKeys.SFIReporting]: true,
        [SovereignFeatureKeys.LivesiteReporting]: true,
        [SovereignFeatureKeys.BAMITenantManagement]: true,
        [SovereignFeatureKeys.TopbarFeedbackPane]: true,
        [SovereignFeatureKeys.CESCVA]: true,
        [SovereignFeatureKeys.EV2Experiments]: true,
        [SovereignFeatureKeys.Lighthouse]: true,
        [SovereignFeatureKeys.Dashboards]: true,
        [SovereignFeatureKeys.FeedbackTelemetry]: true,
        [SovereignFeatureKeys.Copilot]: true,
    },
    ussec: {
        [SovereignFeatureKeys.Experimentation]: true,
        [SovereignFeatureKeys.CloudSwitcher]: true,
        [SovereignFeatureKeys.ProductsExtensions]: false,
        [SovereignFeatureKeys.BuildsDeployments]: true,
        [SovereignFeatureKeys.Controllers]: true,
        [SovereignFeatureKeys.PartnerTests]: true,
        [SovereignFeatureKeys.AzureExperienceQuality]: true,
        [SovereignFeatureKeys.SFIReporting]: true,
        [SovereignFeatureKeys.LivesiteReporting]: true,
        [SovereignFeatureKeys.BAMITenantManagement]: true,
        [SovereignFeatureKeys.TopbarFeedbackPane]: true,
        [SovereignFeatureKeys.CESCVA]: true,
        [SovereignFeatureKeys.EV2Experiments]: true,
        [SovereignFeatureKeys.Lighthouse]: true,
        [SovereignFeatureKeys.Dashboards]: true,
        [SovereignFeatureKeys.FeedbackTelemetry]: true,
        [SovereignFeatureKeys.Copilot]: true,
    },
};

export const hideSovereignFeatureFlags = hideSovereignFeatures[cloud];
